import { render } from "./Upload-images.vue?vue&type=template&id=316d016a&scoped=true"
import script from "./Upload-images.vue?vue&type=script&lang=js"
export * from "./Upload-images.vue?vue&type=script&lang=js"

import "./Upload-images.vue?vue&type=style&index=0&id=316d016a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316d016a"]])

export default __exports__